
<div [ngClass]="[initialized ? 'shown' : 'hidden']" style="position:relative;" class="dash-card-back dash-medium">
  <div *ngIf="!loaded" class="float-top-left-spinner">{{'Loading...'|locale}}</div>

  <select class="float-top-right search-select-single" [(ngModel)]="range" (change)="onChangeRange()">
    <option *ngFor="let level of select_levels" value={{level.key}}>{{ level.name | locale}}</option>
  </select>
  <div id="chart_distribution_kind" class="dash-chart"></div>
</div>